import React, { useEffect, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { cn } from "@/lib/utils";
import {
  CommandInput,
  CommandEmpty,
  CommandList,
  CommandGroup,
  CommandItem,
  Command,
} from "../ui/command";
import { ChevronsUpDownIcon, Check, LoaderCircle, X } from "lucide-react";
import { Button } from "../ui/button";
import { Seller } from "@/interfaces/Seller";
import { getVendeurs } from "@/services/vendor-list.service";

interface FilterSellerSelectProps {
  selectedSeller: Seller;
  setSelectedSeller: (seller: Seller) => void;
}

const FilterSellerSelect: React.FC<FilterSellerSelectProps> = ({
  selectedSeller,
  setSelectedSeller,
}) => {
  const [sellerOpen, setSellerOpen] = useState(false);
  const [sellersLoading, setSellersLoading] = useState(false);
  const [sellers, setSellers] = useState<Seller[]>([]);

  const fetchSellers = async () => {
    try {
      setSellersLoading(true);
      const response = await getVendeurs();
      if (response.status === 200 && response.data.success === true) {
        setSellers(response.data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSellersLoading(false);
    }
  };

  const handleSelectSeller = (seller: Seller) => {
    if (selectedSeller.sellerId === seller.sellerId) {
      setSelectedSeller({} as Seller);
    } else {
      setSelectedSeller(seller);
    }
    setSellerOpen(false);
  };

  useEffect(() => {
    fetchSellers();
  }, []);

  return (
    <div className="flex flex-col gap-2">
      <div className="grid gap-1 ">
        <label className="text-sm font-medium" htmlFor="supplier">
          Fournisseur
        </label>
      </div>
      <div className="flex items-center justify-between gap-2 w-full">
        <Popover open={sellerOpen} onOpenChange={setSellerOpen}>
          <PopoverTrigger asChild>
            <div className="flex items-center gap-2 w-full">
              <Button
                className="w-full justify-between "
                role="combobox"
                variant="outline"
              >
                {selectedSeller.sellerName && selectedSeller
                  ? selectedSeller.sellerName
                  : "Choisir un fournisseur"}
                <ChevronsUpDownIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
              </Button>
              {selectedSeller.sellerId && (
                <Button
                  variant="outline"
                  onClick={() => {
                    setSelectedSeller({} as Seller);
                  }}
                >
                  <X className="w-4 h-4" />
                </Button>
              )}
            </div>
          </PopoverTrigger>
          <PopoverContent className="w-[--radix-popover-trigger-width] max-h-[--radix-popover-content-available-height]">
            <Command>
              <CommandInput className="h-9" placeholder="Chercher un venduer" />
              <CommandEmpty>Aucun vendeur trouvé</CommandEmpty>
              <CommandList>
                <CommandGroup>
                  {sellers &&
                    sellers.map((seller) => (
                      <CommandItem
                        key={seller.sellerId}
                        value={seller.sellerName}
                        onSelect={() => {
                          handleSelectSeller(seller);
                        }}
                      >
                        <Check
                          className={cn(
                            "mr-2 h-4 w-4",
                            selectedSeller.sellerId === seller.sellerId
                              ? "opacity-100"
                              : "opacity-0"
                          )}
                        />
                        {seller.sellerName}
                      </CommandItem>
                    ))}
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>
        {sellersLoading && (
          <LoaderCircle className="animate-spin" color="grey" size={20} />
        )}
      </div>
    </div>
  );
};

export default FilterSellerSelect;
